export const setupSliderDots = (dotsRoot, embla, label = "slide") => {
  if (!dotsRoot) {
    return;
  }

  let dotButtons = [];

  const setDotState = () => {
    const selectedIndex = embla.selectedScrollSnap();

    dotButtons.forEach((dot, index) => {
      dot.classList.toggle("is-selected", index === selectedIndex);
    });
  };

  const renderDots = () => {
    const snapCount = embla.scrollSnapList().length;

    dotsRoot.innerHTML = Array.from({ length: snapCount }, (_, index) => {
      return `<button type="button" class="slider-dots__dot" data-slider-dot="${index}" aria-label="Go to ${label} ${index + 1}"></button>`;
    }).join("");

    dotButtons = Array.from(dotsRoot.querySelectorAll("[data-slider-dot]"));

    dotButtons.forEach((dot) => {
      dot.addEventListener("click", () => {
        embla.scrollTo(Number(dot.dataset.sliderDot));
      });
    });

    setDotState();
  };

  embla.on("select", setDotState);
  embla.on("reInit", renderDots);

  renderDots();
};
